export default (state = {
    data: [],
    isLoading: true
}, action = {}) => {
    if (action.type === 'GET_SITE_STATS') {
        return {
            data: action.payload,
            isLoading: false
        };
    }
    return state;
}